import { OK } from 'http-status-codes';
import { put, takeLatest } from 'redux-saga/effects';
import * as api from './api';
import { types, actions } from './duck';

// BUSINESSES
function* getBusinesses() {
  try {
    yield put(actions.getBusinessesRequest());
    const response = yield api.getBusinesses();
    if (response.status === OK) {
      yield put(actions.getBusinessesSuccess(response.data));
    } else {
      throw new Error(response.statusText);
    }
  } catch (error) {
    yield put(actions.getBusinessesFailure(error.message));
  }
}

// PRODUCTS
function* getProducts() {
  try {
    yield put(actions.getProductsRequest());
    const response = yield api.getProducts();
    
    if (response.status === OK) {
      yield put(actions.getProductsSuccess(response.data));
    } else {
      throw new Error(response.statusText);
    }
  } catch (error) {
    yield put(actions.getProductsFailure(error.message));
  }
}

// PROMOTIONS
function* getPromotions({ advertiserId }) {
  try {
    yield put(actions.getPromotionsRequest());
    const response = yield api.getPromotions(advertiserId);
    if (response.status === OK) {
      const promotions = response.data.data || [];
      yield put(actions.getPromotionsSuccess(promotions));
    } else {
      throw new Error(response.statusText);
    }
  } catch (error) {
    yield put(actions.getPromotionsFailure(error.message));
  }
}

// ROOT SAGA
export default function* saga() {
  yield takeLatest(types.GET_BUSINESSES, getBusinesses);
  yield takeLatest(types.GET_PRODUCTS, getProducts);
  yield takeLatest(types.GET_PROMOTIONS, getPromotions);
}